const regionChoices = [
  { id: 'asia', name: 'Asia' },
  { id: 'europe', name: 'Europe' },
  { id: 'us', name: 'United States' },
];

export default regionChoices;
